import AlLoaderController from './controller';
import templateUrl from './component.tpl.html';

angular
    .module('festzelt-os.modules.core')
    .component(
        'alLoader',
        {
            controller: AlLoaderController,
            controllerAs: 'vm',
            templateUrl,
            bindings: {
                size: '@'
            }
        }
    );



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-loader/component.js